import { handleActions } from 'redux-actions';
import { v4 as uuidv4 } from 'uuid';
import { logoutSuccess } from 'ducks/auth/actions';
import {
  addField,
  updateBuilderFields,
  incidentReportFieldsSuccess,
  deleteIncidentReportFieldSuccess,
  setUserType,
  incidentReportFieldResultsSuccess,
} from './actions';
import initialState from './states';
import { INPUTS_DESCRIPTION } from 'app/types/form-builder';
import _ from 'lodash';
import { ENTITY_STATUS } from 'app/types/constants';
import { INCIDENT_REPORT_USER_TYPES } from './types';

export default handleActions(
  {
    [incidentReportFieldsSuccess](state, { payload: { fields, setupBuilder } }) {
      return {
        ...state,
        fields,
        builderFields: setupBuilder
          ? {
              creator: {
                active: fields.filter(
                  ({ userType, status }) =>
                    userType === INCIDENT_REPORT_USER_TYPES.CREATOR && status === ENTITY_STATUS.ACTIVE
                ),
                deleted: fields.filter(
                  ({ status, userType }) =>
                    userType === INCIDENT_REPORT_USER_TYPES.CREATOR && status === ENTITY_STATUS.DELETED
                ),
              },
              reviewer: {
                active: fields.filter(
                  ({ userType, status }) =>
                    userType === INCIDENT_REPORT_USER_TYPES.REVIEWER && status === ENTITY_STATUS.ACTIVE
                ),
                deleted: fields.filter(
                  ({ status, userType }) =>
                    userType === INCIDENT_REPORT_USER_TYPES.REVIEWER && status === ENTITY_STATUS.DELETED
                ),
              },
            }
          : state.builderFields,
      };
    },
    [addField](state, { payload: { type, index } }) {
      const { name, defaultLabel } = INPUTS_DESCRIPTION[type];
      const newState = _.cloneDeep(state);
      const newField = {
        fieldID: uuidv4(),
        type,
        userType: state.config.userType,
        config: {
          name,
          required: false,
          label: defaultLabel,
        },
      };

      if (state.config.userType === INCIDENT_REPORT_USER_TYPES.CREATOR) {
        const newFields = newState.builderFields.creator.active;
        newFields.splice(_.isNumber(index) ? index : newFields.length, 0, newField);
        newState.builderFields.creator.active = [...newFields];
      } else if (state.config.userType === INCIDENT_REPORT_USER_TYPES.REVIEWER) {
        const newFields = newState.builderFields.reviewer.active;
        newFields.splice(_.isNumber(index) ? index : newFields.length, 0, newField);
        newState.builderFields.reviewer.active = [...newFields];
      }

      return newState;
    },
    [setUserType](state, { payload }) {
      return {
        ...state,
        config: {
          ...state.config,
          userType: payload,
        },
      };
    },
    [updateBuilderFields](state, { payload }) {
      const newState = _.cloneDeep(state);

      if (state.config.userType === INCIDENT_REPORT_USER_TYPES.CREATOR) {
        newState.builderFields.creator = payload(newState.builderFields.creator);
      } else if (state.config.userType === INCIDENT_REPORT_USER_TYPES.REVIEWER) {
        newState.builderFields.reviewer = payload(newState.builderFields.reviewer);
      }

      return newState;
    },
    [deleteIncidentReportFieldSuccess](state, { payload: { fieldID } }) {
      return {
        ...state,
        builderFields: {
          ...state.builderFields,
          creator: {
            ...state.builderFields.creator,
            deleted: state.builderFields.creator.deleted.filter((field) => field.fieldID !== fieldID),
          },
          reviewer: {
            ...state.builderFields.reviewer,
            deleted: state.builderFields.reviewer.deleted.filter((field) => field.fieldID !== fieldID),
          },
        },
      };
    },
    [incidentReportFieldResultsSuccess](state, { payload: { incidentReportID, fieldResults } }) {
      return {
        ...state,
        fieldResults: {
          ...state.fieldResults,
          [incidentReportID]: fieldResults,
        },
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
